'use strict'
module.exports = {
    // PRODUCTION
    ENDPOINT_BASE_URL: '"https://venue-api.peiso.com.au"',
    WEB_URL: '"https://venue.peiso.com.au/"',
    TANDA_URL: '"https://my.tanda.co/api/oauth/authorize?client_id=c2dabdb414a28be50bbef6cfbe7109a96c38298279c88711749147373421038c&redirect_uri=https%3A%2F%2Fvenue.peiso.com.au%2Flogin?type=tanda&response_type=code&scope=roster+timesheet+department+user+cost+settings+me+datastream"',
    XERO_URL: '"https://login.xero.com/identity/connect/authorize?response_type=code&client_id=0965E05CF1364AF9994B5A2B95AD2E3A&redirect_uri=https://venue.peiso.com.au/login&scope=openid profile email  accounting.reports.read accounting.settings accounting.journals.read accounting.attachments.read accounting.transactions  offline_access&state=xero"',
    DEPUTY_URL: '"https://once.deputy.com/my/oauth/login?client_id=64a567becdf815c8b223d69544c7385d24959f08&redirect_uri=https://venue.peiso.com.au/login&response_type=code&scope=longlife_refresh_token"',
    LIGHTSPEED_OSERIES: '"https://my.kounta.com/authorize?client_id=jKdGFIKljlfPRWQJ&redirect_uri=https://venue.peiso.com.au&state=a1b2c3d4&response_type=code"',
    OOLIO_URL:'"https://auth.oolio.dev/authorize?client_id=SALDVEYDUDWtExLePuHmN4p2UtSm1gHb&response_type=code&scope=openid%20profile%20email%20offline_access&redirect_uri=https%3A%2F%2Fsandbox-venue.peiso.com.au%2Flogin?integration=oolio&state={{$randomUUID}}"',
    WEBSOCKET_URL: '"wss://venue-api.peiso.com.au/websocket"',
    INSTANCE_TYPE: '"main"',
    IS_MAIN: '"1"',
    IS_ENABLE_CASHUP: '"1"',
    IS_ENABLE_TRAINING: '"1"',
    IS_ENABLE_RERUN_LABOUR: '"1"',

    // LUCAS RESTAURANT
    // ENDPOINT_BASE_URL: '"https://lucas-venue-api.peiso.com.au"',
    // WEB_URL: '"https://lucasrestaurants.peiso.com.au/"',
    // TANDA_URL: '"https://my.tanda.co/api/oauth/authorize?client_id=c2dabdb414a28be50bbef6cfbe7109a96c38298279c88711749147373421038c&redirect_uri=https%3A%2F%2Fvenue.peiso.com.au%2Flogin?type=tanda&response_type=code&scope=roster+timesheet+department+user+cost+settings+me+datastream"',
    // XERO_URL: '"https://login.xero.com/identity/connect/authorize?response_type=code&client_id=0965E05CF1364AF9994B5A2B95AD2E3A&redirect_uri=https://venue.peiso.com.au/login&scope=openid profile email  accounting.reports.read accounting.settings accounting.journals.read accounting.attachments.read accounting.transactions  offline_access&state=xero"',
    // DEPUTY_URL: '"https://once.deputy.com/my/oauth/login?client_id=f65b88c2bf496c5a553567322d35e7e7f1ab5d03&redirect_uri=https://sandbox-venue.peiso.com.au/login&response_type=code&scope=longlife_refresh_token"',
    // LIGHTSPEED_OSERIES: '"https://my.kounta.com/authorize?client_id=jKdGFIKljlfPRWQJ&redirect_uri=https://venue.peiso.com.au&state=a1b2c3d4&response_type=code"',
    // WEBSOCKET_URL: '"wss://lucas-venue-api.peiso.com.au/websocket"',
    // INSTANCE_TYPE: '"lucas"',
    // IS_MAIN: '"0"',
    // IS_ENABLE_CASHUP: '"0"',
    // IS_ENABLE_TRAINING: '"0"',
    // IS_ENABLE_EXECUTIVE_EOD: "'1'",

    // SANDBOX
    // ENDPOINT_BASE_URL: '"https://sandbox-venue-api.peiso.com.au"',
    // WEB_URL: '"https://sandbox-venue.peiso.com.au/"',
    // TANDA_URL: '"https://my.tanda.co/api/oauth/authorize?client_id=7dfadd9bafc4c400f053309d718f2c9c712eb61feb3e9c1dd3e86d3108377ffa&redirect_uri=https%3A%2F%2Fsandbox-venue.peiso.com.au%2Flogin?type=tanda&response_type=code&scope=roster+timesheet+department+user+cost+settings+me+datastream"',
    // XERO_URL: '"https://login.xero.com/identity/connect/authorize?response_type=code&client_id=20A39760C9914CFCA25A482C03598984&redirect_uri=https://sandbox-venue.peiso.com.au/login&scope=openid profile email  accounting.reports.read accounting.settings  offline_access&state=xero"',
    // DEPUTY_URL: '"https://once.deputy.com/my/oauth/login?client_id=f65b88c2bf496c5a553567322d35e7e7f1ab5d03&redirect_uri=https://sandbox-venue.peiso.com.au/login&response_type=code&scope=longlife_refresh_token"',
    // LIGHTSPEED_OSERIES: '"https://my.kounta.com/authorize?client_id=C9w4Nd96jdGtl3xP&redirect_uri=https://sandbox-venue.peiso.com.au&state=a1b2c3d4&response_type=code"',
    // WEBSOCKET_URL: '"wss://sandbox-venue-api.peiso.com.au/websocket"',
    // INSTANCE_TYPE: '"sandbox"',
    // IS_MAIN: '"0"',
    // IS_ENABLE_CASHUP: '"1"',
    // IS_ENABLE_TRAINING: '"0"',
    // IS_ENABLE_RERUN_LABOUR: '"1"',


    IS_ENABLE_VENUE_SUMMARY: 1,
    MAIN_URI: '"https://venue.peiso.com.au/"',
    LUCAS_URI: '"https://lucasrestaurants.peiso.com.au/"',
    // MAIN APP
    GOOGLE_STORE: '"https://play.google.com/store/apps/details?id=peiso.mobile.app"',
    APPLE_STORE: '"https://apps.apple.com/us/app/peiso/id1671477405"',
    TRAINING_URL: '"https://peiso.allaraonline.com/"'
}



//////////////////
// WEBPACK FOOTER
// ./config.env.js
// module id = 3UBt
// module chunks = 1